var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 59,
    viewBox: "0 0 43 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9987 21.3543C42.9987 33.1466 21.5065 58.9872 21.5065 58.9872C21.5065 58.9872 0.0142822 33.1466 0.0142822 21.3543C0.0142822 9.56203 9.62515 0 21.4936 0C33.362 0 42.9858 9.56203 42.9858 21.3543H42.9987Z",
    fill: "#F78745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.814 30.0192V18.0089C31.814 12.3563 27.1827 7.76758 21.5065 7.76758C15.8302 7.76758 11.199 12.3691 11.199 18.0089V30.032H31.8269L31.814 30.0192ZM21.1711 13.2407H21.2227C23.2351 13.2407 24.8606 14.6763 24.8606 16.4324C24.8606 18.1884 23.2351 19.624 21.2227 19.624H21.1711C19.1328 19.624 17.4815 18.1884 17.4815 16.4324C17.4815 14.6763 19.1328 13.2407 21.1711 13.2407ZM17.7137 19.4573L26.2409 28.5836H17.7137V19.4573ZM21.4936 9.19035C26.3829 9.19035 30.3562 13.1382 30.3562 17.9961V28.5708H29.1436L21.042 20.9955L21.0162 20.9698C21.184 20.9955 21.3259 20.9955 21.4936 20.9955C24.2801 20.9955 26.5248 18.9446 26.5248 16.4195C26.5248 13.8945 24.2672 11.8436 21.4936 11.8436C19.9842 11.8436 18.6426 12.4332 17.7008 13.3946L17.675 12.2538V12.0872H14.9143C16.5398 10.3055 18.8748 9.17753 21.4807 9.17753L21.4936 9.19035ZM12.6309 17.9961C12.6309 16.3683 13.0824 14.8558 13.8565 13.5356H15.9206V28.5708H12.6309V18.0089V17.9961Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 59,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3daec7482814da0ba3e2b82ed1535e71.svg";
export { ForwardRef as ReactComponent };